"use strict";

module.exports = [
  { level: "1", value: "male", label: "Male" },
  { level: "2", value: "female", label: "Female" },
  { level: "3", value: "other", label: "Other" },
  { level: "4", value: "unknown", label: "Unknown" }
];
